import React, { useState } from "react";
import {
  Page,
  Document,
  PDFViewer,
  Image,
  View,
  Text,
  StyleSheet,
} from "@react-pdf/renderer";
import { Request } from "../../hooks/Request";
import { numberWithDecimals, validateArray } from "../../utils/validate";
import * as numeros_a_palabras from "numeros_a_palabras";
import dayjs from "dayjs";

const styles = StyleSheet.create({
  page: {
    fontSize: 7,
    padding: 0,
  },
  title: {
    fontSize: 8,
    paddingTop: 5,
  },
  table: {
    width: "auto",
    borderWidth: 1,
    borderColor: "#000",
    marginTop: 10,
    borderLeft: 0,
  },
  tableRow: {
    flexDirection: "row",
    borderTopWidth: 1,
    borderColor: "#000",
  },
  tableCol: {
    borderLeftWidth: 1,
    borderColor: "#000",
    padding: 2,
  },
  smallCol: { width: "4%" },
  mediumCol: { width: "14%" },
  largeCol: { width: "30%" },
  tableCell: {
    fontSize: 6,
  },
  headerCell: {
    fontSize: 8,
    fontWeight: "bold",
    textAlign: "center",
  },
  container: {
    width: "100%",
    height: "100%",
    position: "relative",
  },
  content: {
    position: "relative",
    padding: 20,
  },
  texto: {
    paddingTop: 2,
    fontSize: 8,
  },
  noRowBorder: {
    flexDirection: "row",
    borderTopWidth: 0, // elimina la línea horizontal entre filas
  },
  cellWithBorder: {
    borderLeftWidth: 1,
    borderColor: "#000",
    padding: 2,
  },
  bgImage: {
    position: "absolute",
    top: "0%",
    left: "0%",
    width: "105%", // mantienes tu tamaño mayor
    height: "100%", // centra la imagen
    opacity: 0.5,
    transform: "translate(-30%, -0%)",
  },
});

const listFields = [
  "solicitudDocumentos",
  "fechaPagoDeLaDim",
  "fechaDePlanilla",
  "a1NúmeroDeDeclaración",
  "f10TotalValorCifAduana",
  "nroBl",
  "canal(Rojo,AmarilloOVerde)",
  "a4AduanaDeDespacho",
  "asignarRégimenDeImportación",
  "nroFacturaComercial",
  "a-TributosYOtrosConceptosAduaneros",
  "b-OtrosGastosDeImportacion/Exportacion",
  "c-GastosDeOperaciones",
  "fechaDeCotización",
  "descripciónDeLaMercancía",
  "cm-003-FacturaComercial",
  "bultos",
  "peso",
  "a4AduanaDeDespacho",
  "asignarRégimenDeImportación",
  "codigoDeInterno",
  "designacionDeLiquidador",
  // "tributosAduaneros",
  // "erogaciones",
  // "honorariosProfesionales",
];

// Función para parsear el objeto JSON de description4
const parseDescription4 = (description4) => {
  if (!description4) return { Orig: 0, Cop: 0, Fot: 0, Dig: 0, Otro: 0 };

  try {
    const parsed = JSON.parse(description4);
    return {
      Orig: parsed.Orig || 0,
      Cop: parsed.Cop || 0,
      Fot: parsed.Fot || 0,
      Dig: parsed.Dig || 0,
      Otro: parsed.Otro || 0,
    };
  } catch (error) {
    // Si no es un JSON válido, verificar si es el formato anterior de string simple
    if (typeof description4 === "string") {
      return {
        Orig: description4 === "Orig" ? 1 : 0,
        Cop: description4 === "Cop" ? 1 : 0,
        Fot: description4 === "Fot" ? 1 : 0,
        Dig: description4 === "Dig" ? 1 : 0,
        Otro: description4 === "Otro" ? 1 : 0,
      };
    }
    return { Orig: 0, Cop: 0, Fot: 0, Dig: 0, Otro: 0 };
  }
};

const DocumentRequestPdf = (props) => {
  const {
    procedure,
    notesValueData = [],
    values = {},
    name,
    addListFields = [],
  } = props;
  const [isSolicitud, setIsSolicitud] = useState(false);

  const { data, loading, call } = Request({
    urlApi: `/Procedure/${procedure.id || procedure.procedureId}/dataValues?${[
      ...listFields,
      ...addListFields,
    ]
      .map((field) => `fieldnames=${field}`)
      .join("&")}`,
  });

  if (!loading && !data) {
    return null;
  }

  const MyDoc = ({ data }) => {
    const fondoURL =
      "https://res.cloudinary.com/dh15miacl/image/upload/fondo_bffzk1.jpg";

    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.container}>
            <Image src={fondoURL} style={styles.bgImage} />
            <View style={styles.content}>
              {/* ------------------------- ENCABEZADO ------------------------- */}
              <View style={styles.table}>
                <View style={[styles.tableRow, { borderTopWidth: 0 }]}>
                  <View style={[styles.tableCol, { width: "25%" }]}>
                    <Text
                      style={[
                        styles.tableCell,
                        {
                          fontSize: 17,
                          fontWeight: "500",
                          textAlign: "center",
                          padding: 5,
                        },
                      ]}
                    >
                      PATROSS
                    </Text>
                  </View>

                  <View style={[styles.tableCol, { width: "55%" }]}>
                    <Text
                      style={[
                        styles.tableCell,
                        {
                          fontSize: 17,
                          fontWeight: "500",
                          textAlign: "center",
                          padding: 5,
                        },
                      ]}
                    >
                      {name
                        ? "ENTREGA DE DOCUMENTOS"
                        : isSolicitud
                        ? "SOLICITUD DE DOCUMENTOS"
                        : "RECEPCIÓN DE DOCUMENTOS"}
                    </Text>
                  </View>

                  <View
                    style={[
                      styles.tableCol,
                      { width: "20%", padding: 5, textAlign: "center" },
                    ]}
                  >
                    <Text style={[styles.tableCell, { fontSize: 15 }]}>
                      N° TRÁMITE
                    </Text>
                    <Text style={[styles.tableCell, { fontSize: 10 }]}>
                      {data.codigoDeInterno}
                    </Text>
                  </View>
                </View>
              </View>

              {/* ---------------------- DATOS DE CABECERA ---------------------- */}
              <View style={{ marginTop: 10 }}>
                {/* Línea 1 */}
                <View style={[styles.texto, { flexDirection: "row" }]}>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={{ width: "22%" }}>Fecha Inicio: </Text>
                    <Text style={{ width: "25%" }}>
                      {dayjs(data.procFechaDeInicio).format("DD/MM/YYYY")}
                    </Text>
                  </View>

                  <View style={{ flexDirection: "row", width: "58%" }}>
                    <Text>Cliente: </Text>
                    <Text>{data?.company?.razonSocial || "N/A"}</Text>
                  </View>
                </View>

                {/* Línea 2 */}
                <View style={[styles.texto, { flexDirection: "row" }]}>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={{ width: "20%" }}>Liquidador: </Text>
                    <Text style={{ width: "25%" }}>
                      {data.designacionDeLiquidador}
                    </Text>
                  </View>

                  <View style={{ flexDirection: "row", width: "50%" }}>
                    <Text style={{ width: "25%" }}>N° Referencia: </Text>
                    <Text style={{ width: "25%" }}>{data.codigoDeInterno}</Text>
                  </View>
                </View>

                {/* Línea 3 */}
                <View style={[styles.texto, { flexDirection: "row" }]}>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={{ width: "20%" }}>Aduana: </Text>
                    <Text style={{ width: "25%" }}>
                      {data.a4AduanaDeDespacho}
                    </Text>
                  </View>

                  <View style={{ flexDirection: "row" }}>
                    <Text style={{ width: "25%" }}>Patrón: </Text>
                    <Text style={{ width: "25%" }}>
                      {data.asignarRégimenDeImportación}
                    </Text>
                  </View>
                </View>

                {/* Línea 4 */}
                <View style={[styles.texto, { flexDirection: "row" }]}>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={{ width: "20%" }}>Descripción: </Text>
                    <Text style={{ width: "25%" }}>
                      {data.descripciónDeLaMercancía}
                    </Text>
                  </View>

                  {/* <View style={{ flexDirection: "row" }}>
                    <Text style={{ width: "25%" }}>Tipo Despacho: </Text>
                    <Text style={{ width: "25%" }}>
                      {data.asignarRégimenDeImportación}
                    </Text>
                  </View> */}
                </View>
              </View>

              {/* --------------------------- TABLA ---------------------------- */}
              <View style={[styles.table, { marginTop: 15, borderTop: 0 }]}>
                {/* -------- ENCABEZADO (CON TODAS LAS LÍNEAS) -------- */}
                <View style={[styles.tableRow, { borderBottomWidth: 1 }]}>
                  <View style={[styles.tableCol, { width: "3%" }]}>
                    <Text style={styles.headerCell}>N°</Text>
                  </View>
                  <View
                    style={[
                      styles.tableCol,
                      { width: isSolicitud ? "97%" : "30%" },
                    ]}
                  >
                    <Text style={styles.headerCell}>Documento</Text>
                  </View>

                  {!isSolicitud && (
                    <>
                      <View style={[styles.tableCol, { width: "15%" }]}>
                        <Text style={styles.headerCell}>N° Documento</Text>
                      </View>
                      <View style={[styles.tableCol, { width: "5%" }]}>
                        <Text style={styles.headerCell}>Orig</Text>
                      </View>
                      <View style={[styles.tableCol, { width: "5%" }]}>
                        <Text style={styles.headerCell}>Cop.</Text>
                      </View>
                      <View style={[styles.tableCol, { width: "5%" }]}>
                        <Text style={styles.headerCell}>Fot.</Text>
                      </View>
                      <View style={[styles.tableCol, { width: "5%" }]}>
                        <Text style={styles.headerCell}>Dig</Text>
                      </View>
                      <View style={[styles.tableCol, { width: "5%" }]}>
                        <Text style={styles.headerCell}>Otro</Text>
                      </View>
                      <View style={[styles.tableCol, { width: "10%" }]}>
                        <Text style={styles.headerCell}>Fech. Recep.</Text>
                      </View>
                      <View style={[styles.tableCol, { width: "9%" }]}>
                        <Text style={styles.headerCell}>Fecha Doc.</Text>
                      </View>
                      <View style={[styles.tableCol, { width: "8%" }]}>
                        <Text style={styles.headerCell}>Estado</Text>
                      </View>
                    </>
                  )}
                </View>

                {/* -------- FILAS DEL BODY (SIN LÍNEA HORIZONTAL) -------- */}
                {data.solicitudDocumentosSubDatas &&
                validateArray(data.solicitudDocumentosSubDatas)
                  ? data.solicitudDocumentosSubDatas.map((item, index) => {
                      // Parsear description4 solo si no es solicitud
                      const origData = !isSolicitud
                        ? parseDescription4(item.description4)
                        : null;

                      return (
                        <View style={styles.noRowBorder} key={index}>
                          <View
                            style={[styles.cellWithBorder, { width: "3%" }]}
                          >
                            <Text>{index + 1}</Text>
                          </View>

                          <View
                            style={[
                              styles.cellWithBorder,
                              { width: isSolicitud ? "97%" : "30%" },
                            ]}
                          >
                            <Text>{item.label}</Text>
                          </View>

                          {!isSolicitud && (
                            <>
                              <View
                                style={[
                                  styles.cellWithBorder,
                                  { width: "15%" },
                                ]}
                              >
                                <Text>{item.description}</Text>
                              </View>

                              {/* Mostrar las cantidades de cada tipo */}
                              <View
                                style={[styles.cellWithBorder, { width: "5%" }]}
                              >
                                <Text>
                                  {origData?.Orig > 0 ? origData.Orig : ""}
                                </Text>
                              </View>

                              <View
                                style={[styles.cellWithBorder, { width: "5%" }]}
                              >
                                <Text>
                                  {origData?.Cop > 0 ? origData.Cop : ""}
                                </Text>
                              </View>

                              <View
                                style={[styles.cellWithBorder, { width: "5%" }]}
                              >
                                <Text>
                                  {origData?.Fot > 0 ? origData.Fot : ""}
                                </Text>
                              </View>

                              <View
                                style={[styles.cellWithBorder, { width: "5%" }]}
                              >
                                <Text>
                                  {origData?.Dig > 0 ? origData.Dig : ""}
                                </Text>
                              </View>

                              <View
                                style={[styles.cellWithBorder, { width: "5%" }]}
                              >
                                <Text>
                                  {origData?.Otro > 0 ? origData.Otro : ""}
                                </Text>
                              </View>

                              <View
                                style={[
                                  styles.cellWithBorder,
                                  { width: "10%" },
                                ]}
                              >
                                <Text>
                                  {dayjs(item.creationDate).format(
                                    "DD/MM/YYYY"
                                  )}
                                </Text>
                              </View>

                              <View
                                style={[styles.cellWithBorder, { width: "9%" }]}
                              >
                                <Text>{item.description2}</Text>
                              </View>

                              <View
                                style={[styles.cellWithBorder, { width: "8%" }]}
                              >
                                <Text>{"-"}</Text>
                              </View>
                            </>
                          )}
                        </View>
                      );
                    })
                  : null}
              </View>
            </View>

            {/* ----------------- PIE DE PÁGINA ----------------- */}
            <Image
              src="https://res.cloudinary.com/dh15miacl/image/upload/v1764688956/logo.png"
              style={{
                position: "absolute",
                bottom: 10,
                left: 20,
                width: 100,
              }}
            />
          </View>
        </Page>
      </Document>
    );
  };

  return (
    <div>
      {/* Controles arriba del PDF */}
      {!name && (
        <div
          style={{
            marginBottom: 15,
            padding: "10px",
            backgroundColor: "#f5f5f5",
            borderRadius: "4px",
          }}
        >
          <label
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <input
              type="checkbox"
              checked={isSolicitud}
              onChange={(e) => setIsSolicitud(e.target.checked)}
              style={{ marginRight: "8px", cursor: "pointer" }}
            />
            <span style={{ fontSize: "14px", fontWeight: "500" }}>
              {isSolicitud
                ? "✓ Mostrando SOLICITUD DE DOCUMENTOS"
                : "Mostrar como SOLICITUD DE DOCUMENTOS"}
            </span>
          </label>

          <div
            style={{
              fontSize: "12px",
              color: "#666",
              marginTop: "5px",
              marginLeft: "24px",
            }}
          >
            {isSolicitud
              ? "La tabla solo muestra N° y Documento"
              : "La tabla muestra todas las columnas (Recepción de Documentos)"}
          </div>
        </div>
      )}

      {data && (
        <PDFViewer
          style={{
            width: 900,
            height: window.innerHeight - 150, // Reducida para dar espacio al checkbox
          }}
        >
          <MyDoc
            data={
              addListFields && validateArray(addListFields)
                ? {
                    ...data,
                    solicitudDocumentosSubDatas:
                      data[`${addListFields[0]}SubDatas`],
                  }
                : data
            }
          />
        </PDFViewer>
      )}
    </div>
  );
};

export default DocumentRequestPdf;
